<template>
    <div>
        <v-flex>

            <v-card>
                <v-card-title>
                    <v-layout row wrap >
                        <v-flex xs12 md5 ma-1>
                            <InputSearch :label="`Buscar x DNI, nombre, etc`" @search="search">
                            </InputSearch>                            
                        </v-flex>
                        
                        <v-flex xs12 md3 ma-1>
                            <v-select
                                v-model="selectedModalidadFilter"
                                item-text="nombre"
                                item-value="id"
                                :items="comboModalidades"
                                label="Modalidad"       
                                                         
                            ></v-select>                         
                        </v-flex>
                        <v-flex xs12 md3 ma-1>
                            <v-select
                                v-model="selectedStatesFilter"
                                :items="stateFilterOptions"
                                label="Estado"
                            ></v-select>                         
                        </v-flex>

                    </v-layout>
                </v-card-title>


                <div>

                    <div class="tools">
                        <v-btn color="primary" small flat @click="openSendEmailDialog()">Email a Seleccionados</v-btn>
                        <v-btn color="primary" small flat @click="openSendEmailDialog(true)"> Enviar email a todos</v-btn>
                        <v-btn color="secondary" small flat @click="imprimirListado">
                            <v-icon left small>print</v-icon>
                            Imprimir Listado
                        </v-btn>

                      
                        <!-- <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                color="secondary"
                                dark
                                v-on="on"
                                small
                                >
                                Descargas <v-icon right dark>cloud_download</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-tile>
                                    <v-list-tile-title>Planilla Rufus</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile>
                                    <v-list-tile-title>Listado Inscriptos</v-list-tile-title>
                                </v-list-tile>
                            </v-list>
                            </v-menu> -->
                        </div>

                    <InscripcionesTabla :items="items" :evento="evento" 
                        @abrirMarcarPagada="abrirMarcarPagada"
                        @abrirEditarInscripcion="abrirEditarInscripcion"
                        @abrirVerInscripcion="abrirVerInscripcion" @abrirBorrarInscripcion="abrirBorrarInscripcion"
                        @refrescarDatos="() => { this.getDataFromServer() }" @paginationChange="paginationChange"
                        :loading="loading" :totalItems="totalItems" ref="inscripcionesTabla" />

                </div>
            </v-card>


        </v-flex>

        <EditarInscripcionDialog ref="dialogInscripcion" :inscripcion="inscripcionEditar"
            @refrescarDatos="() => { this.getDataFromApi() }" />

        <VerInscripcionDialog ref="dialogVerInscripcion" :states="allStates" @state-changed="onStateChanged" @snackbar="onSnackbar"/>

        <BorrarInscripcionDialog :inscripcion="inscripcionBorrar" ref="dialogBorrarInscripcion"
            @refrescarDatos="() => { this.getDataFromApi() }" />

        <SendEmailDialog :eventId="evento.id" :inscriptions="inscriptionsSelected" :allSelected="allSelected" :query="query"
            ref="dialogSendEmail" />

        <MarcarPagadaDialog ref="dialogMarcarPagada" :inscripcion="inscripcionEditar"
        @refrescarDatos="() => { this.getDataFromApi() }"/>

        <v-snackbar v-model="snackbarVisible" :color="snackbarColor" :timeout="4000">
            {{ snackbarMessage }}
        </v-snackbar>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import api from '@/api/inscripcion'
import EditarInscripcionDialog from '../../../../components/inscripcion/editar-inscripcion/EditarInscripcionDialog.vue';
import VerInscripcionDialog from '../../../../components/inscripcion/ver-inscripcion/VerInscripcionDialog.vue';
import BorrarInscripcionDialog from '../../../../components/inscripcion/borrar-inscripcion/BorrarInscripcionDialog.vue';
import SendEmailDialog from '../../../../components/inscripcion/email/SendEmailDialog.vue';
import MarcarPagadaDialog from '../../../../components/inscripcion/inscripcion-pagada/MarcarPagadaDialog.vue';


import InscripcionesTabla from './InscripcionesTabla.vue'
import debounce from '@/directives/debounce';
import InputSearch from '@/components/common/InputSearch.vue';
import inscripcionTablaMixins from '@/mixins/utils';
import moment from 'moment';

// const defaultStatesFilter = ['PAGO_REALIZADO', 'PAGO_BONIFICADO'];
const stateFilterOptions = [
                {
                    text: 'Todos',
                    value: [],
                },
                {
                    text: 'Bonificado',
                    value: ['PAGO_BONIFICADO'],
                },
                {
                    text: 'No Paga',
                    value: ['PAGO_NO_PAGA'],
                },
                {
                    text: 'Pagado',
                    value: ['PAGO_REALIZADO'],
                },
                {
                    text: 'Pagado / Bonificado',
                    value: ['PAGO_REALIZADO','PAGO_BONIFICADO'],
                },
                {
                    text: 'Pago expirado',
                    value: ['PAGO_EXPIRADO'],
                },
                {
                    text: 'Pago pendiente',
                    value: ['PAGO_PENDIENTE'],
                },
                {
                    text: 'Pago rechazado',
                    value: ['PAGO_RECHAZADO'],
                },
                {
                    text: 'Pago en revisión',
                    value: ['PAGO_EN_REVISION'],
                },
            ]
export default {
     
    directives: { debounce },
    mixins: [inscripcionTablaMixins],
    components: {
        "EditarInscripcionDialog": EditarInscripcionDialog,
        "VerInscripcionDialog": VerInscripcionDialog,
        "BorrarInscripcionDialog": BorrarInscripcionDialog,
        "SendEmailDialog": SendEmailDialog,
        "InscripcionesTabla": InscripcionesTabla,
        "MarcarPagadaDialog": MarcarPagadaDialog,
        "InputSearch": InputSearch
    },
    data() {
        return {
            snackbarVisible: false,
            snackbarMessage: '',
            snackbarColor: 'success',
            selectedStatesFilter: stateFilterOptions[1],
            allStates: stateFilterOptions,
            selectedModalidadFilter: null,
            inscriptionsSelected: [

            ],
            allSelected: true,
            model: null,
            editarInscripcion: {
                state: '',
            },
            dialogInscripcion: false,
            inscripcionEditar: {},
            inscripcionBorrar: {},
            loadingEvento: true,
            loading: false,
            personaEditar: {},
            pagination: {
                search: '',
                descending: false,
                page: 1,
                rowsPerPage: 20,
                sortBy: "id",
                totalItems: 0,
                filters: {
                    estados: JSON.stringify(stateFilterOptions[1].value),
                    modalidad: ''
                },
            },

            items: [],
            totalItems: 0,
            stateFilterOptions: stateFilterOptions
        }
    },
    computed: mapState({
        comboModalidades: state =>  [{id:0, nombre: "Todas"},...state.eventos.eventoActual.modalidades],
        evento: state => state.eventos.eventoActual,
        modalidades: state => state.eventos.eventoActual.modalidades,
        steps: state => [
            {
                text: 'Eventos',
                disabled: false,
                href: '/#/backoffice/events/list'
            },
            {
                text: state.eventos.eventoActual.nombre,
                disabled: true,
                href: '/#/backoffice/event/' + state.eventos.eventoActual.id
            }
        ],
        query: function () {
            let filters = {
                search: this.pagination.search,
                filters: {
                    estados: this.selectedStatesFilter.value
                }
            }
            if(this.selectedModalidadFilter){
                filters.filters.modalidad = this.selectedModalidadFilter;
            }
            return filters;
        }

    }),
    created() {
        scroll(0, 0);
        let eventoId = this.$route.params.id;
        this.$store.dispatch('eventos/getEventoById', eventoId).then(() => {
            this.loadingEvento = false;

        })

    },
    watch: {
        selectedStatesFilter(){
            this.pagination.filters.estados = JSON.stringify(this.selectedStatesFilter);
            this.pagination.page = 1;
        },
        selectedModalidadFilter() {
             this.pagination.filters.modalidad = this.selectedModalidadFilter;
            this.pagination.page = 1;
         },
        pagination: {
            handler() {
                this.getDataFromApi()
            },
            deep: true
        },

    },
    mounted() {

    },
    methods: {
        paginationChange(pagination) {
            this.pagination = { ...this.pagination, ...pagination }
        },
        search(value) {
            this.pagination.search = value;
            this.pagination.page = 1;
            this.getDataFromApi();
        },
        getDataFromApi() {
            this.loading = true;
            let eventoId = this.$route.params.id;
            api.getInscriptosEventoOrganizadorId(eventoId, this.pagination).then((res) => {
                // console.log(res);
                this.items = res.data;
                this.totalItems = res.total;
                this.loading = false;
 
                this.inscriptionsSelected = res.data
            })
        },
        getDataFromServer() {
            // Alias para compatibilidad
            this.getDataFromApi();
        },

        abrirEditarPersonaDialog(persona) {
            this.$refs.dialogPersona.abrirDialog();
            this.personaEditar = persona;
        },

        abrirEditarInscripcion(inscripcion) {
            this.inscripcionEditar = JSON.parse(JSON.stringify(inscripcion));
            this.$refs.dialogInscripcion.abrirDialog();
        },

        abrirVerInscripcion(inscripcion) {
            this.$refs.dialogVerInscripcion.abrirDialog(inscripcion);
        },

        onStateChanged(inscripcion) {
            // Actualizar la inscripción en la lista local
            const index = this.items.findIndex(item => item.id === inscripcion.id);
            if (index !== -1) {
                // Actualizar el estado en el item de la lista (el estado viene en minúsculas del backend)
                this.$set(this.items[index], 'state', inscripcion.state);
            }
            // También refrescar los datos del servidor para asegurar consistencia
            this.getDataFromApi();
        },

        onSnackbar(payload) {
            this.snackbarMessage = payload.text || payload;
            this.snackbarColor = payload.color || 'success';
            this.snackbarVisible = true;
        },

        abrirMarcarPagada(inscripcion) {
            this.inscripcionEditar = JSON.parse(JSON.stringify(inscripcion));

            this.$refs.dialogMarcarPagada.abrirDialog();
        },

        abrirBorrarInscripcion(inscripcion) {
            this.inscripcionBorrar = JSON.parse(JSON.stringify(inscripcion));
            this.$refs.dialogBorrarInscripcion.abrirDialog();
        },
        openSendEmailDialog(all = false) {
            this.allSelected = all;
            if (!all) {
                this.inscriptionsSelected = this.$refs.inscripcionesTabla.getSelected();
            }
            this.$refs.dialogSendEmail.openDialog();
        },

        async imprimirListado() {
            this.loading = true;
            let eventoId = this.$route.params.id;
            
            // Obtener todas las inscripciones sin paginación
            const paginationAll = {
                ...this.pagination,
                page: 1,
                rowsPerPage: -1 // -1 significa obtener todas
            };

            try {
                const res = await api.getInscriptosEventoOrganizadorId(eventoId, paginationAll);
                const todasLasInscripciones = res.data || [];
                
                this.generarVistaImprimible(todasLasInscripciones);
            } catch (error) {
                // console.error('Error al obtener inscripciones:', error);
                this.$store.commit('app/SET_MESSAGE', 'Error al obtener las inscripciones para imprimir');
                this.$store.commit('app/SET_SHOW', true);
            } finally {
                this.loading = false;
            }
        },

        generarVistaImprimible(inscripciones) {
            const fechaImpresion = moment().format('DD/MM/YYYY HH:mm');
            const nombreEvento = this.evento.nombre || 'Evento';
            
            // Crear HTML para la impresión
            let html = `
<!DOCTYPE html>
<html>
<head>
    <meta charset="UTF-8">
    <title>Listado de Inscripciones - ${nombreEvento}</title>
    <style>
        @media print {
            @page {
                margin: 1cm;
                size: landscape;
            }
            body {
                margin: 0;
                padding: 0;
            }
        }
        body {
            font-family: Arial, sans-serif;
            font-size: 9px;
            margin: 20px;
        }
        .header {
            text-align: center;
            margin-bottom: 20px;
            border-bottom: 2px solid #000;
            padding-bottom: 10px;
        }
        .header h1 {
            margin: 0;
            font-size: 18px;
            font-weight: bold;
        }
        .header p {
            margin: 5px 0;
            font-size: 12px;
        }
        table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 10px;
        }
        th, td {
            border: 1px solid #000;
            padding: 3px;
            text-align: left;
            font-size: 8px;
        }
        th {
            background-color: #f0f0f0;
            font-weight: bold;
            text-align: center;
        }
        tr:nth-child(even) {
            background-color: #f9f9f9;
        }
        .footer {
            margin-top: 20px;
            text-align: center;
            font-size: 9px;
            color: #666;
        }
    </style>
</head>
<body>
    <div class="header">
        <h1>${nombreEvento}</h1>
        <p>Listado Completo de Inscripciones - Información de Pagos</p>
        <p>Fecha de impresión: ${fechaImpresion}</p>
        <p>Total de inscripciones: ${inscripciones.length}</p>
    </div>
    <table>
        <thead>
            <tr>
                <th>ID</th>
                <th>Documento</th>
                <th>Nombre/Apellido</th>
                <th>Modalidad</th>
                <th>Estado Pago</th>
                <th>Fecha Inscripción</th>
                <th>Fecha Límite Pago</th>
                <th>Fecha Subida Comprobante</th>
                <th>Categoría</th>
                <th>Ciudad</th>
            </tr>
        </thead>
        <tbody>
`;

            inscripciones.forEach((inscripcion) => {
                const documento = this.getDocumento(inscripcion);
                const nombreApellido = this.getNombreYApellido(inscripcion);
                const modalidad = inscripcion.modalidad ? inscripcion.modalidad.nombre : '-';
                const categoria = this.getCategoria(inscripcion) || '-';
                const ciudad = this.getCiudad(inscripcion) || '-';
                const estado = this.getEstadoLabel(inscripcion.state);
                
                // Fechas de pago
                const fechaInscripcion = inscripcion.created_at ? moment(inscripcion.created_at).format('DD/MM/YYYY HH:mm') : '-';
                const fechaLimitePago = inscripcion.expires_at ? moment(inscripcion.expires_at).format('DD/MM/YYYY HH:mm') : '-';
                const fechaSubidaComprobante = inscripcion.payment_receipt_uploaded_at ? moment(inscripcion.payment_receipt_uploaded_at).format('DD/MM/YYYY HH:mm') : '-';

                html += `
            <tr>
                <td>${inscripcion.id || '-'}</td>
                <td>${documento}</td>
                <td>${nombreApellido}</td>
                <td>${modalidad}</td>
                <td>${estado}</td>
                <td>${fechaInscripcion}</td>
                <td>${fechaLimitePago}</td>
                <td>${fechaSubidaComprobante}</td>
                <td>${categoria}</td>
                <td>${ciudad}</td>
            </tr>
`;
            });

            html += `
        </tbody>
    </table>
    <div class="footer">
        <p>Generado el ${fechaImpresion}</p>
    </div>
</body>
</html>
`;

            // Abrir ventana de impresión
            const ventanaImpresion = window.open('', '_blank');
            ventanaImpresion.document.write(html);
            ventanaImpresion.document.close();
            
            // Esperar a que se cargue el contenido y luego imprimir
            ventanaImpresion.onload = () => {
                setTimeout(() => {
                    ventanaImpresion.print();
                }, 250);
            };
        },

        getEstadoLabel(estado) {
            const labels = {
                pago_realizado: 'Pagado',
                pago_bonificado: 'Bonificado',
                pago_no_paga: 'No Paga',
                pago_pendiente: 'Pendiente',
                pago_en_revision: 'En Revisión',
                pago_rechazado: 'Rechazado',
                pago_expirado: 'Expirado'
            };
            return labels[estado] || estado || 'Sin estado';
        },

    }

}
</script>                   
